import React from 'react';
import PropTypes from 'prop-types';

import { ProfileSettingsConfig } from '@Constants/rx-user/constants';
import TwoLevelRadio from '@Pages/ProfileSettings/Preferences/components/TwoLevelRadio';
import { RadioButtonGroup } from '@els/els-react--radio-button';
import ProfileSettingsAccordionItem from '@Pages/ProfileSettings/Components/ProfileSettingsAccordionItem';
import './SearchStructure.scss';

function SearchStructure({ title, options = [], currentOption, onChange = () => {}, onSave = () => {}, onClose = () => {} }) {
  const handleChange = (value) => {
    onChange(null, value);
  };

  return (
    <ProfileSettingsAccordionItem
      onClose={onClose}
      onSave={onSave}
      label={ProfileSettingsConfig.Labels.searchStructure}
      dataE2E="profile-settings-accordion-row-search-structure-as"
      title={title}
      value={title}
      validateOnSave
      className="search-structure-accordion-item">
      <fieldset className="search-structure__fieldset">
        <legend className="sr-only">{ProfileSettingsConfig.Labels.searchStructure}</legend>
        {options.map((option) => {
          const key = `${option.name}-${option.value}`;
          return (
            <div key={key} className="search-drawing clearfix">
              {option.type === 'radio' &&
                (option.subOptions ? (
                  <TwoLevelRadio option={option} value={currentOption} onChange={handleChange} />
                ) : (
                  <RadioButtonGroup.Option
                    id={key}
                    className="search-structure__radio-option"
                    name={option.name}
                    label={option.title}
                    value={option.value}
                    disabled={option.disabled}
                    checked={currentOption === option.value}
                    onChange={() => handleChange(option.value)}
                    aria-label={`Search this structure ${option?.title?.toLowerCase?.() || ''}`}
                  />
                ))}
            </div>
          );
        })}
      </fieldset>
    </ProfileSettingsAccordionItem>
  );
}

SearchStructure.propTypes = {
  currentOption: PropTypes.string,
  options: PropTypes.array,
  title: PropTypes.string,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

export default SearchStructure;
